module.exports = __webpack_public_path__ + "media/logos/commission-plan-58dab089.svg";